import React from 'react';
import {
  Grid,
  Button,
  ImageList,
  ImageListItem
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

const ImagesStep = ({ handleImageUpload, images, t }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <input
          accept="image/*"
          style={{ display: 'none' }}
          id="image-upload"
          type="file"
          onChange={handleImageUpload}
        />
        <label htmlFor="image-upload">
          <Button
            variant="outlined"
            component="span"
            startIcon={<AddIcon />}
          >
            {t('editRoommate.addImage')}
          </Button>
        </label>
      </Grid>
      
      <Grid item xs={12}>
        <ImageList cols={3} gap={8}>
          {images.map((image) => (
            <ImageListItem key={image.id}>
              <img
                src={image.url}
                alt=""
                loading="lazy"
                style={{ height: 200, objectFit: 'cover' }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Grid>
    </Grid>
  );
};

export default ImagesStep; 